<template>
  <div class="outer">
    <div class="verify-address-modal">
      <div v-if="!notFound" class="verify-address-modal-body">
        <address-modal-header :title="'Where will this order be delivered?'" :showCloseModal="false" />
        <div class="address-inputs">
          <div class="input-wrapper">
            <label for="street" class="label">Street Name</label>
            <input
              ref="streetAddressInput"
              type="text"
              name="street"
              class="input"
              id="streetVerifyAddressInput"
              v-model="address"
              @keyup.enter="codeAddress()"
              aria-label="Enter Street Address for delivery"
            />
          </div>
          <div class="input-wrapper">
            <label for="city" class="label">City</label>
            <input type="text" name="city" class="input" v-model="city" @keyup.enter="codeAddress()" aria-label="Enter City for delivery" />
          </div>
          <div class="half-wrapper">
            <div class="input-wrapper input-wrapper--half">
              <label for="state" class="label">State</label>
              <input
                type="text"
                name="state"
                class="input"
                v-model="state"
                @keyup.enter="codeAddress()"
                aria-label="Enter State for delivery"
              />
            </div>
          </div>
        </div>
        <button class="yellow-button" type="button" @click="codeAddress()">
          <span class="yellow-button-text"> Continue </span>
        </button>
      </div>
      <div v-if="notFound" class="verify-address-modal-body">
        <address-modal-header :title="'We could not locate your address!'" :showCloseModal="false" />
        <button class="yellow-button" type="button" ref="tryAgainInput" @click="notFound = false">
          <span class="yellow-button-text"> Try Again? </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AddressModalHeader from '../rest-list/components/ModalItems/AddressModalHeader.vue'
var axios = require('axios')
const debounce = require('lodash/debounce')
var geocoder = new google.maps.Geocoder()
import { mapActions } from 'vuex'

export default {
  name: 'VerifyAddressModal',
  components: {
    AddressModalHeader,
  },
  created() {
    this.verifyZone()
  },
  mounted() {
    var lat, lng, myLatlng, autocomplete
    var place = false
    var self = this
    myLatlng = new google.maps.LatLng(this.mapCenterLat, this.mapCenterLng)
    var acOptions = {
      location: myLatlng,
      radius: 150000, // 150Km
      types: ['address'],
      componentRestrictions: { country: 'us' },
    }
    autocomplete = new google.maps.places.Autocomplete(document.getElementById('streetVerifyAddressInput'), acOptions)
    var geocoder = new google.maps.Geocoder()
    autocomplete.setFields(['address_components', 'geometry'])
    google.maps.event.addListener(autocomplete, 'place_changed', function () {
      place = autocomplete.getPlace()
      if (!place.geometry) {
        return false
      }
      var streetno, route, placeZip, city, state
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0]
        if (addressType === 'street_number') {
          streetno = place.address_components[i].short_name
        }
        if (addressType === 'route') {
          route = place.address_components[i].short_name
        }
        if (addressType === 'postal_code') {
          placeZip = place.address_components[i].short_name
        }
        if (addressType === 'locality') {
          city = place.address_components[i].short_name
        }
        if (addressType === 'administrative_area_level_1') {
          state = place.address_components[i].short_name
        }
      }
      self.address = streetno + ' ' + route
      self.city = city
      self.state = state
    })
  },
  data: function () {
    return {
      notFound: false,
      address: this.defaultAddress ? this.defaultAddress : '',
      city: this.defaultCity ? this.defaultCity : '',
      state: this.defaultState ? this.defaultState : '',
    }
  },
  props: {
    defaultAddress: String,
    defaultCity: String,
    defaultState: String,
    staffOverride: String,
    addItemObj: {
      type: Object,
      default: () => {},
    },
    mapCenterLat: [String, Number],
    mapCenterLng: [String, Number],
    restZone: [String, Number],
    restName: String,
  },
  methods: {
    ...mapActions({
      addItemToCart: 'restMenu/addItemToCart',
    }),
    verifyZone() {
      var self = this
      var params = new URLSearchParams()
      params.append('mode', 'checkZone')
      axios.post('/selectZone.pl', params).then((response) => {
        if (response.data.selectZone) {
          self.$nextTick(function () {
            document.body.classList.add('not-scrollable')
            self.$refs.streetAddressInput.focus()
            return true
          })
        } else {
          return false
        }
      })
    },
    codeAddress: debounce(
      function () {
        if (this.address === '') {
          alert('You must enter a street address!')
          return false
        }

        var address = this.address + ' ' + this.city + ' ' + this.state
        var self = this
        geocoder.geocode(
          {
            address: address,
          },
          async function (results, status) {
            if (
              status === google.maps.GeocoderStatus.OK &&
              (results[0].geometry.location_type === 'ROOFTOP' ||
                results[0].geometry.location_type === 'RANGE_INTERPOLATED' ||
                results[0].geometry.location_type === 'GEOMETRIC_CENTER')
            ) {
              var result = await self.whichZone(results[0].geometry.location)
              if (result) {
                await self.addItemToCart({
                  itemId: self.addItemObj.itemId,
                  qty: self.addItemObj.qty,
                  options: self.addItemObj.options,
                  whofor: self.addItemObj.whofor,
                  specInstructions: self.addItemObj.specInstructions,
                  getCartData: false,
                })
                location.reload()
              }
              return true
            } else {
              self.notFound = true
              self.$nextTick(function () {
                self.$refs.tryAgainInput.focus()
              })
              return false
            }
          }
        )
      },
      1000,
      { leading: true, trailing: false }
    ),
    whichZone(LatLng) {
      var self = this
      var params = new URLSearchParams()
      params.append('mode', 'whichzone')
      params.append('lat', LatLng.lat())
      params.append('lng', LatLng.lng())
      return axios.post('/selectZone.pl', params).then((response) => {
        if (response.data.errors) {
          var errorMsg
          for (var eachError in response.data.errors) {
            errorMsg = response.data.errors[eachError]
          }
          alert(errorMsg)
          return false
        }
        if (response.data.success) {
          if (response.data.success.blocked) {
            alert('Sorry!' + '\n\n' + response.data.success.blocked + '\n\n' + response.data.success.reason)
            return false
          } else if (response.data.success.zoneID !== self.restZone) {
            self.setJSCookie()
            window.location.replace('/restaurants/?available=no&rest_name=' + self.restName)
          } else {
            self.setJSCookie()
            return true
          }
        }
      })
    },
    setJSCookie() {
      this.setCookie('address', this.address, 1800)
      this.setCookie('city', this.city, 1800)
      this.setCookie('state', this.state, 1800)
      this.setCookie('deliveryProfile', '', 1800)

      return false
    },
    setCookie(c_name, value, exdays) {
      var exdate = new Date()
      exdate.setDate(exdate.getDate() + exdays)
      var c_value = escape(value) + (exdays == null ? '' : '; expires=' + exdate.toUTCString()) + '; path=/' + ';SameSite=Lax'
      document.cookie = c_name + '=' + c_value
    },
  },
}
</script>

<style lang="scss" scoped>
.outer {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
}

.verify-address-modal {
  position: fixed;
  border-radius: 5px;
  top: 10%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 100%;
  max-width: 730px;
  z-index: 100;
  max-height: calc(100vh - 20%);
  overflow: auto;
}

.verify-address-modal-body {
  background-color: $white;
  padding: 40px;

  @media (min-width: $mobileLandscape) {
    padding: 50px 40px 50px 80px;
  }
}

.address-inputs {
  margin-bottom: 50px;
  padding-right: 20px;

  @media (min-width: $mobileLandscape) {
    padding-right: 80px;
  }
}

.input-wrapper {
  border-bottom: 1px solid $gray_1;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 15px 0 5px;
  justify-content: space-between;

  @media (min-width: $mobileLandscape) {
    flex-wrap: nowrap;
  }
}

.input-wrapper.input-wrapper--half {
  width: 100%;

  @media (min-width: $mobileLandscape) {
    width: 50%;

    &:not(:last-of-type) {
      margin-right: 25px;
    }
  }
}

.half-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (min-width: $mobileLandscape) {
    flex-wrap: nowrap;
  }
}

.label {
  font-size: 1.5rem;
  font-weight: 700;
  padding: 0 10px;
  white-space: nowrap;
}

.label.label--with-optional {
  display: flex;
  flex-direction: column;
}

.optional-text {
  color: $royal;
  font-size: 1.2rem;
  font-weight: 400;
}

input[type='text'].input {
  width: 100%;
  font-size: 1.5rem;
  background-color: $white;
  margin: 0;
  border-radius: 0;
  border: 0;

  &:focus {
    outline: none;
  }
}

.yellow-button {
  @include transition(background-color, transform);
  font-size: 1.8rem;
  font-weight: 900;
  text-align: center;
  padding: 11px 30px;
  background-color: $gold;
  border-radius: 22.5px;
  box-shadow: $box-shadow;

  &:hover,
  &:focus {
    transform: translate(0, -2px);
    background-color: $royal;
  }
}

.yellow-button-text {
  line-height: 1;
  margin: 0 15px;
}
</style>
